/* ===================================================================
   BAMBOOVE — GIU MEGA MENU MO KHI RE CHUOT TRONG HANG HEADER
   Phien 65 · 13/10/2026 · ban 2 (boc ham `deactivate`)
   -------------------------------------------------------------------
   LOI DO DUOC (kho 1440): muc "Shop" chi la DAI HEP 55px
   (rect [412,55,55,23]); "hop an toan" cua Horizon
   (`.menu-list__link::after`, `inset-inline: 0`) cung hep dung bang vay.
   => Re XUONG THANG thi khong sao; RE CHEO ra ngoai dai do (ma van o trong
   hang header) la mat hover => theme dong ngay.
   Do: re cheo sang trai => TAT o buoc 3 tai (403,70), chi lech mep muc 9px.

   CACH SUA: boc ham `deactivate` cua <header-menu> (KHONG sua ma Horizon):
     · roi MUC MENU nhung con tro VAN TRONG HANG HEADER => KHONG dong
     · con tro vao lai muc/ngan, hoac roi HAN khu header => tra ve ham goc
   Vi sao boc duoc: `assets/component.js` d.307 lay `instance[method]` NGAY LUC
   su kien xay ra => `on:pointerleave="/deactivate"` se goi ham nay.
   =================================================================== */

/* ===================================================================
   BAMBOOVE — CĂN CỘT LINK CỦA NGĂN MEGA NẰM NGAY DƯỚI MỤC ĐANG RÊ
   Phiên 65 · 13/10/2026 · bản 3 (thêm phần căn lề)
   -------------------------------------------------------------------
   LỖI ANH CHỈ: mở ngăn "Shop" mà các lựa chọn (Knee-High · Crew · Bundles ·
   Shop All) nằm tận RÌA TRÁI trang, cách xa chữ "Shop" đang rê chuột.
   ĐO ĐƯỢC (khổ 1440): mục "Shop" ở x=405 · lưới ngăn [40 … 1400] ·
   link con đầu tiên ở x=40 ⇒ **LỆCH 365px**.
   Nguyên nhân: Horizon trải ngăn FULL-WIDTH rồi đặt cột link ở lề trái trang.
   CÁCH SỬA: khi mở ngăn, đo độ lệch = (x mục menu − x cột link) rồi DỊCH cột link
   sang phải đúng bằng đó. Cột sản phẩm KHÔNG đụng ⇒ không xô lệch.
   · Dùng `transform` (không phải đệm): đệm làm ĐỔI BỐ CỤC ⇒ chữ trong link bị bó
     còn 12px và ngăn cao vọt 331px → 717px (đã đo, 13/10/2026).
   · Chặn trên: chừa đủ chỗ cho link dài nhất rồi mới tới cột sản phẩm
     (mục "Help" nằm xa hơn "Shop" nên lệch lớn hơn).
   =================================================================== */

const MQ_DESKTOP = window.matchMedia('(min-width: 990px)');
let dangGiu = null;

/* ⚠️ ĐÃ BỎ cách đệm trái: đệm ĐỔI BỐ CỤC ⇒ lưới ngăn (3 cột) bị bó, chữ vỡ
   thành 12px và ngăn cao vọt 331px → 717px (đo 13/10/2026). Thay bằng DỊCH CHUYỂN
   (`transform`) — KHÔNG đụng bố cục nên cột sản phẩm và chiều cao giữ nguyên. */

/** Cột LINK trong lưới ngăn (bỏ qua cột sản phẩm có ảnh) */
function cotLinkCua(luoi) {
  const cot = luoi.children[0];
  if (!cot || !cot.querySelector('a')) return null;
  const con = [...cot.children];
  const coAnh = (e) => !!e.querySelector('img');
  if (con.length > 1 && con.some(coAnh)) {
    return con.find((e) => !coAnh(e) && e.querySelector('a')) || null;
  }
  return cot;
}

/** Đo & dịch cột link cho vừa nằm DƯỚI mục menu đang rê */
function canLe(item) {
  const hm = document.querySelector('header-menu');
  const sub = item && item.querySelector('.menu-list__submenu');
  const luoi = sub && sub.querySelector('.mega-menu__grid');
  if (!hm || !luoi || !MQ_DESKTOP.matches) return null;

  const cot = cotLinkCua(luoi);
  if (!cot) return null;

  cot.style.transform = ''; // đo ở vị trí GỐC (không tính lần dịch trước)
  const r = item.getBoundingClientRect();
  const g = luoi.getBoundingClientRect();
  const c0 = cot.getBoundingClientRect();

  // mốc phải CHỪA CHỖ: phần tử nằm NGOÀI cột link mà gần mốc gốc nhất (cột sản phẩm)
  let moc = Infinity;
  luoi.querySelectorAll('*').forEach((e) => {
    if (cot.contains(e)) return;
    const x = e.getBoundingClientRect().left;
    if (x > c0.left + 1) moc = Math.min(moc, x);
  });

  // bề ngang chữ của link DÀI NHẤT trong cột (để biết cần chừa bao nhiêu)
  let rongChu = 0;
  cot.querySelectorAll('a').forEach((a) => {
    rongChu = Math.max(rongChu, a.getBoundingClientRect().width);
  });

  const gioiHan = moc === Infinity ? Infinity : Math.max(0, Math.round(moc - c0.left - rongChu - 24));
  const le = Math.max(0, Math.min(Math.round(r.left - c0.left), gioiHan));

  cot.style.transform = le ? 'translateX(' + le + 'px)' : '';
  window.__bbMenuLe = le; // để máy đo đọc lại
  return le;
}

function hinhHeader() {
  const hc = document.querySelector('#header-component') || document.querySelector('.header-section');
  return hc ? hc.getBoundingClientRect() : null;
}

function trongHangHeader(x, y) {
  const r = hinhHeader();
  return !!r && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
}

/** Muc menu cap 1 CO NGAN (bo qua muc trong ngan keo dien thoai) */
function mucMenu(el) {
  if (!(el instanceof Element)) return null;
  const li = el.closest('.menu-list__list-item');
  if (!li || li.closest('.menu-list--mobile')) return null;
  return li.querySelector('.menu-list__submenu') ? li : null;
}

/** Goi lai dung ham dong cua theme (khong tu viet lai logic) */
function baoThemeDong(li) {
  try {
    li.dispatchEvent(new PointerEvent('pointerleave'));
  } catch (err) {
    li.dispatchEvent(new Event('pointerleave'));
  }
}

function boc() {
  const el = document.querySelector('header-menu');
  if (!el) return false;
  if (el.__bbBocDeactivate) return true;
  const goc = el.deactivate;
  if (typeof goc !== 'function') return false;

  el.deactivate = function (event) {
    const li = event ? mucMenu(event.target) : null;
    // Roi MUC MENU ma con tro VAN TRONG HANG HEADER => GIU MO
    if (li && MQ_DESKTOP.matches && trongHangHeader(event.clientX, event.clientY)) {
      dangGiu = li;
      return;
    }
    dangGiu = null;
    return goc.call(this, event);
  };
  el.__bbBocDeactivate = true;
  return true;
}

/* Con tro ROI HAN khu header ma ngan van dang giu => dong (goi ham goc) */
document.addEventListener(
  'pointermove',
  (event) => {
    if (!dangGiu) return;
    const duong = event.composedPath ? event.composedPath() : [];
    const trenMuc = duong.some(
      (n) => n instanceof Element && n.classList && n.classList.contains('menu-list__list-item')
    );
    if (trenMuc) { dangGiu = null; return; }                    // da vao lai muc/ngan => theme lo
    if (trongHangHeader(event.clientX, event.clientY)) return;  // van trong hang header => giu
    const li = dangGiu;
    dangGiu = null;
    baoThemeDong(li);
  },
  true
);

/* Cuon trang => dong ngan dang giu */
document.addEventListener(
  'scroll',
  () => {
    if (!dangGiu) return;
    const li = dangGiu;
    dangGiu = null;
    baoThemeDong(li);
  },
  { passive: true, capture: true }
);

/* <header-menu> co the len sau => thu lai vai lan */
if (!boc()) {
  let dem = 0;
  const thu = setInterval(() => {
    if (boc() || ++dem > 40) clearInterval(thu);
  }, 250);
}

/* ── Căn cột link mỗi lần MỞ ngăn: bọc hàm `activate` (cùng cách với `deactivate`) ── */
function bocActivate() {
  const el = document.querySelector('header-menu');
  if (!el) return false;
  if (el.__bbBocActivate) return true;
  const goc = el.activate;
  if (typeof goc !== 'function') return false;

  el.activate = function (event) {
    const kq = goc.call(this, event);
    const li = event ? mucMenu(event.target) : null;
    if (li) {
      canLe(li);
      // theme có thể vẽ lại nội dung ngăn ngay sau đó => đo lại 1 nhịp nữa
      requestAnimationFrame(() => canLe(li));
    }
    return kq;
  };
  el.__bbBocActivate = true;
  return true;
}

if (!bocActivate()) {
  let dem2 = 0;
  const thu2 = setInterval(() => {
    if (bocActivate() || ++dem2 > 40) clearInterval(thu2);
  }, 250);
}

/* Thu nhỏ về khổ ĐIỆN THOẠI => GỠ dịch chuyển (ngăn điện thoại phải về như cũ) */
let henXoa = null;
window.addEventListener('resize', () => {
  clearTimeout(henXoa);
  henXoa = setTimeout(() => {
    if (MQ_DESKTOP.matches) return;
    document.querySelectorAll('.mega-menu__grid > :first-child').forEach((c) => {
      c.style.transform = '';
    });
  }, 250);
});
